import { Layout, Text, BlockStack } from '@shopify/polaris';
import { Carousel } from 'antd';
import React, { ReactElement } from 'react';
import { DI, DIProps } from '../../../../../Core';
import { useTranslation } from 'react-i18next';

interface Props extends DIProps { }

function Imageuploadtutorial(props: Props): ReactElement {
    const { t } = useTranslation();
    const onChange = (currentSlide: number) => {
    };
    return <>
        <Carousel afterChange={onChange} autoplay autoplaySpeed={5000} infinite>
            <div>
                <Layout>
                    <Layout.Section>
                        <BlockStack>
                            <Text as='p' fontWeight='semibold'>{t("Moving Image From Right to Left")}</Text>
                            <Text as='p' tone='subdued'>{t("Select the Image of your choice from the Shopify's Image list on the right and simply drag that Image to the left in one of the 9 empty spaces.")}</Text>
                            <Text as='p' tone='subdued'>
                                {t("Note: Once set, you can edit all images in the future except the Primary Image. The Primary Image is the Image that is first displayed when a customer sees your Product Lisiting on Amazon.")}
                            </Text>
                        </BlockStack>
                    </Layout.Section>
                    {/* <Layout.Section variant="oneThird">
                        <img style={{ width: '100%', height: '100%' }} src={"https://multi-account.sellernext.com/apps/assests/stepone.gif"} />
                    </Layout.Section> */}
                </Layout>
            </div>
            <div>
                <Layout>
                    <Layout.Section>
                        <BlockStack>
                            <Text as='p' fontWeight='semibold'>{t("Setting the Image Position.")}</Text>
                            <Text as='p' tone='subdued'>
                                {t("You can set the position of images by either using the Right or Left Navigation keys that you'll find when hovering over the image whose position you want to change. The other way is by simply dragging that image, except for the Primary Image, to the position of your choice.")}
                            </Text>
                        </BlockStack>
                    </Layout.Section>
                    {/* <Layout.Section variant="oneThird">
                        <img style={{ width: '100%', height: '100%' }} src={"https://multi-account.sellernext.com/apps/assests/steptwo.gif"} />
                    </Layout.Section> */}
                </Layout>
            </div>
            <div>
                <Layout>
                    <Layout.Section>
                        <BlockStack>
                            <Text as='p' fontWeight='semibold'>{t("Deleting an Image.")}</Text>
                            <Text as='p' tone='subdued'>
                                {t("To delete any of the 9 images on the left, just hover over the image you want to delete. You'll find a Red-colored 'Dustbin' icon next to the Right Navigation Key. Just Click on that Dustbin icon and that image will be simply removed from the 9 product images for your Amazon product listing.")}
                            </Text>
                        </BlockStack>
                    </Layout.Section>
                    {/* <Layout.Section variant="oneThird">
                        <img style={{ width: '100%', height: '100%' }} src={"https://multi-account.sellernext.com/apps/assests/stepthree.gif"} />
                    </Layout.Section> */}
                </Layout>
            </div>
            <div>
                <Layout>
                    <Layout.Section>
                        <BlockStack>
                            <Text as='p' fontWeight='semibold'>
                                {t("Adding your own Custom Image")}
                            </Text>
                            <Text as='p' tone='subdued'>
                                {t("To add an image of your choice stored on your local device in the list of images on the right, just click on the '+ Add Image' Button present in the lower right corner of the screen. Then, select the image that you want to upload from your device. You'll now find that image showing up as the First Image in the long list of images present on the Right. Now click on this newly added image to set it as one of the 9 Featured images for your Amazon product listing.")}
                            </Text>
                        </BlockStack>
                    </Layout.Section>
                    {/* <Layout.Section variant="oneThird">
                        <img style={{ width: '100%', height: '100%' }} src={"https://multi-account.sellernext.com/apps/assests/stepthree.gif"} />
                    </Layout.Section> */}
                </Layout>
            </div>
        </Carousel>
    </>;
}

export default DI(Imageuploadtutorial);